import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import AddToGroup from '../../../Icons/AddToGroup';
import { BiDataHook, BiEventType } from '../../../biLogger/constants';
import { MobileContext } from '../../../Context';
import CustomNotificationProvider, { useCustomNotifications, } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
import PopoverNotification from '../../../Notifications/PopoverNotification';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import { ThemeOptions } from '../../../publicSession';
import s from './AddToGroupButton.scss';
export var AddToGroupButton = function (_a) {
    var _b;
    var actionBarType = _a.actionBarType, onToggleGroupsPanel = _a.onToggleGroupsPanel, onShowMobileGroupsPanel = _a.onShowMobileGroupsPanel, isGroupsPanelOpen = _a.isGroupsPanelOpen, withTooltip = _a.withTooltip, deviation = _a.deviation;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var notifications = useCustomNotifications([
        NotificationType.GroupPrompt,
    ]).notifications;
    var hasNotification = notifications.length > 0 && !((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.fortune);
    var button = (React.createElement(ActionBarButton, { onClick: function () {
            return isMobile
                ? onShowMobileGroupsPanel(deviation)
                : onToggleGroupsPanel(actionBarType);
        }, dataHook: BiDataHook.DEVIATION_GROUPS_COUNTER, tooltip: withTooltip === false || hasNotification
            ? undefined
            : t('actionbar.addToGroup'), isRelatedPanelOpen: isGroupsPanelOpen, biData: isGroupsPanelOpen
            ? undefined
            : {
                evid: BiEventType.ADD_TO_GROUP_CLICK,
                deviationid: deviation.deviationId,
            }, notificationTypes: [NotificationType.AddToGroup2] },
        React.createElement(ActionBarIcon, { icon: AddToGroup })));
    return (React.createElement(CustomNotificationProvider, { queueName: getDeviationNotificationQueue(deviation) }, hasNotification ? (React.createElement(PopoverNotification, { notificationTypes: [NotificationType.GroupPrompt], contentClassName: s['popper-content'], forceTheme: ThemeOptions.DARK }, button)) : (button)));
};
AddToGroupButton.displayName = 'AddToGroupButton';
export default AddToGroupButton;
//# sourceMappingURL=AddToGroupButton.js.map